import { Flex, Text } from "@chakra-ui/react";
import colors from "core/resources/theme/colors";

interface TagDiaTrancasacaoProps {
  diaTransacao: string;
}

export default function TagDiaTransacao({
  diaTransacao,
}: TagDiaTrancasacaoProps) {
  return (
    <Flex
      minW="60px"
      h="60px"
      align="center"
      alignItems="center"
      justifyContent="center"
      rounded="full"
      bg={colors.white}
      position="absolute"
      left="-75px"
      p={2}
    >
      <Text fontSize="30px" fontWeight="medium">
        {diaTransacao}
      </Text>
    </Flex>
  );
}
